const doc = [({"en":({"js":({"admin":({"contacts":({"edit":({"school_content":({"school_information":"School information"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;